import React from "react";
import UserPointListState, { UserPointListProps } from "./UserPointList.models";
import './UserPointList.scss';
import PointsService from "../../../services/management/PointsService";
import { PointsUserDTO } from "../../../models/dtos/management/PointsUserDTO";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";
import UserPointModal from "../user-point-modal/UserPointModal";
import { WordRestrictions } from "../../../models/extension/WordExtention";

export default class UserPointList extends React.PureComponent<UserPointListProps, UserPointListState>{

    pointsService: PointsService;
    constructor(props: any) {
        super(props);
        this.pointsService = new PointsService();
        this.state = { points: [], showModal: false, parentId: 0 };
    }

    componentDidMount = () => {
        this.getData()
    }
    showDetail = (pointId: number) => {
        let self = this;

        self.setState({ showModal: true, parentId: pointId });
    }

    closeModal = () => {
        let self = this;

        self.setState({ showModal: false });
    }

    getData = () => {
        let self = this;
        self.pointsService.getPoints().then(function (response) {
            self.setState({ points: response });
        });
    }

    render(): React.ReactNode {
        let { points } = this.state;
        let content;
        if (points.length > 0) {
            content = (<>
                <div className="col-12 user-points-list-area notspace">
                    {points.map((point, key) => {
                        return (<div key={key} className="col-12 notspace margin-top box-shadow" onClick={() => this.showDetail(point.parentId)}>
                                <div className="tk-inline card-boundel" >
                                    <div className="col-2 notspace">
                                        <div className={"points " + (point.point > 0 ? " success-images" : "danger-images")}>
                                            <label className="point-number">
                                                {
                                                    point.point > 0 ? <span>+</span> : ''
                                                }
                                                {point.point}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-10 notspace" style={{ textAlign: "right", marginRight: " 20px" }}>
                                        <div className="pd-detail">
                                            <div className="course-title tk-tooltip">
                                                <label>
                                                    {WordRestrictions(point.pointTitle,25)}
                                                </label>
                                                <label className="tk-tooltiptext buttom">{point.pointTitle}</label>
                                            </div>
                                            <div className="point-subtitle">
                                                <label>برای مشاهده جزئیات کلیک کنید</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>);
                    })}
                </div >
            </>);
        }
        else content = (<NotFoundDataInDate title="موردی جهت نمایش یافت نشد" />);
        return (<>
            <div className="col-12 user-points-list-area notspace" style={{ paddingTop: "18px !important" }}>
                <label>لیست امتیازات کسب شده</label>
            </div>
            {content}

            <UserPointModal closeModal={this.closeModal} parentId={this.state.parentId} showModal={this.state.showModal} />
        </>);
    }
}